import QuantityUnit from '../enums/QuantityUnit';

interface WeightedValue {
    bruto?: unknown;
    netto?: unknown;
}

export default function quantityUnitValue(input: WeightedValue | null | undefined, unit: string): unknown {

    if(!input) {

        return null;
    }

    return unit === QuantityUnit.BRUTO ? input.bruto : input.netto;
}
